export default __webpack_public_path__ + "static/media/Ballroll_00073.e6f291c0.png";